export default {
  'viewportDownload.warningMessage': {
    enabled: true,
    value: 'Not For Diagnostic Use',
  },
};
